import React, { lazy, Suspense } from "react";
const CKEditor = lazy(() => import("./CkEditor"));

function CKEditorUI({ onChange, value, afterPaste }) {
  const editorConfiguration = {
    height: "300px", // Set the desired height here
  };

  

  return (
    <div>
      <Suspense fallback="Loading...">
        <CKEditor
          data={value === "" || !value || value === null ? " " : value}
          onInit={(editor) => {
            console.log("Editor is ready to use!", editor);
          }}
          onChange={(event, editor) => {
            onChange({ editor });
            console.log({ event, editor });
          }}
          onBlur={(event, editor) => {
            console.log("Blur.", editor);
          }}
          onFocus={(event, editor) => {
            console.log("Focus.", editor);
          }}
          config={editorConfiguration}
        />
      </Suspense>
    </div>
  );
}

export default CKEditorUI;
